import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { ScrollText } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { ProposalsPage } from "./pages/ProposalsPage";

/** Search params on /proposals. `?proposal=<id>` is the share link — it opens
 *  that saved proposal in the calculator (see ProposalsPage's link-load flow). */
export interface ProposalsSearch {
  proposal?: string;
}

function validateSearch(raw: Record<string, unknown>): ProposalsSearch {
  const out: ProposalsSearch = {};
  if (typeof raw.proposal === "string" && raw.proposal.length > 0) {
    out.proposal = raw.proposal;
  }
  return out;
}

export const proposalsModule: FeatureModule = {
  key: "proposals",
  nav: {
    label: "Proposals",
    icon: ScrollText,
    to: "/proposals",
    requires: "proposals.read",
    order: 90,
    group: "Revenue",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/proposals",
      component: guarded("proposals.read", ProposalsPage),
      validateSearch,
    }),
  ] as unknown as AnyRoute[],
};
